// Styles
import { wrapper, button } from "./styles";
// Components
import CustomLink from "@/components/custom-link";

const CareersButton: React.FC = () => {
  return (
    <div className={wrapper}>
      <CustomLink url={"/careers"}>
        <button className={button} type={"button"}>
          Careers
        </button>
      </CustomLink>
    </div>
  );
};

export default CareersButton;
